import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * ルート `/` はダッシュボードへリダイレクト。
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
